import React from 'react'
import Style from './style'
import DurationInput from '../DurationInput'
import DefaultButton from '../DefaultButton'

const PrizeHeaderControls = ({
	durationRef,
	onKeyDown,
	defaultDuration = 3000,
	onAddPrize,
	eventData,
}) => {
	return (
		<Style.Container>
			<DurationInput
				inputRef={durationRef}
				defaultValue={eventData?.duration || defaultDuration}
				onKeyDown={onKeyDown}
			/>
			<DefaultButton small fitWidth clickEvent={onAddPrize}>
				구간 추가
			</DefaultButton>
		</Style.Container>
	)
}

export default PrizeHeaderControls
